var smallLogo = typeof smallLogoOverride !== 'undefined' ? smallLogoOverride : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
    bigLogo = typeof bigLogoOverride !== 'undefined' ? bigLogoOverride : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i<ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return decodeURIComponent(c.substring(name.length,c.length));
    }
    return "";
}

function setCookie(cname, cvalue) {
    var d = new Date();
    d.setTime(d.getTime() + (365*24*60*60*1000));
    var expires = "expires="+d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

function getParam(name) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)", "i"),
        results = regex.exec(window.location.href);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function checkLogo() {
    // Getting query params
    window.paramSmallLogo = getParam('small_logo');
    window.paramBigLogo = getParam('big_logo');

    var cookieBigLogo = getCookie('bigLogo'),
        cookieSmallLogo = getCookie('smallLogo'),
        loginLogo = document.querySelector('.b-login__logo');

    if (paramSmallLogo) {
        smallLogo = paramSmallLogo;
        smallLogo = smallLogo.indexOf('//') === -1 ? '//' + smallLogo : smallLogo;
        setCookie('smallLogo', smallLogo);
    } else if (cookieBigLogo) {
        bigLogo = cookieBigLogo;
        bigLogo = bigLogo.indexOf('//') === -1 ? '//' + bigLogo : bigLogo;
        setCookie('bigLogo', bigLogo);
    }

    if (paramBigLogo) {
        bigLogo = paramBigLogo;
        bigLogo = bigLogo.indexOf('//') === -1 ? '//' + bigLogo : bigLogo;
        setCookie('bigLogo', bigLogo);
    } else if (cookieSmallLogo) {
        smallLogo = cookieSmallLogo;
        smallLogo = smallLogo.indexOf('//') === -1 ? '//' + smallLogo : smallLogo;
        setCookie('smallLogo', smallLogo);
    }
    if (loginLogo) {
        if (!bigLogo && cookieLogo) {
            bigLogo = cookieLogo;
        }
        if (bigLogo) {
            loginLogo.src = bigLogo;
        }
    } else {
        if (bigLogo) {
            document.querySelector('#main-loading img').src = bigLogo;
        }

        if (smallLogo) {
            document.querySelector('#main-menu .logo').src = smallLogo;
            document.querySelector('#main-menu .logo').setAttribute('data-src', smallLogo);
        }
    }
}

checkLogo();
